import apiOptions from '@/api/public/kiriminaja';
import authHelper from '@/helpers/auth';

const defaultState = () => ({
	courier: [],
	ongkir: [],
	provinces: [],
	cities: [],
	subdistricts: [],
	listBank: [],
	bankAccountList: [],
	paymentMethodList: [],
	latitude: null,
	longitude: null,
	sosmedAccountList: [],
	siteConfig: (authHelper.getSiteConfigData() != null) ? authHelper.getSiteConfigData() : {
		meta_title: 'Your Company',
		logo: 'https://s3-id-jkt-1.kilatstorage.id/assets.talko.id/images/user/text207168.png',
		favicon: 'https://s3-id-jkt-1.kilatstorage.id/assets.talko.id/images/user/online-shop-logo-template-premium-vector-png30967.ico',
		midtrans_status: "0",
		midtrans_client_key: "",
		payment_manual_status: "0"
	},
});

const state = defaultState();

const getters = {
};

const mutations = {
	setSiteConfig(state, data) {
		state.siteConfig = data
		authHelper.setSiteConfigData(data)
	},
	setLatLon(state, data) {
		state.latitude = data.latitude
		state.longitude = data.longitude
	},
	setCourier(state, data) {
		state.courier = data
	},
	setOngkir(state, data) {
		state.ongkir = data
	},
	setProvince(state, data) {
		state.provinces = data
	},
	setCity(state, data) {
		state.cities = data
	},
	setSubdistrict(state, data) {
		state.subdistricts = data
	},
	setListBank(state, data) {
		state.listBank = data
	},
	setBanAccountList(state, data) {
		state.bankAccountList = data
	},
	setPaymentMethodList(state, data) {
		state.paymentMethodList = data
	},
	setSosmedAccountList(state, data) {
		state.sosmedAccountList = data
	},
	clearOptions(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	async getSiteConfig({ commit }) {
		return new Promise((resolve) => {
			apiOptions.getSiteConfig().then(({ data: { data } }) => {
				commit('setSiteConfig', data.results);
				resolve(data.results);
			}).catch(() => {
				commit('setSiteConfig', {
					meta_title: 'Your Title',
					logo: 'Your Logo',
					favicon: 'Your Favicon'
				});
				reject(true)
			});
		});
	},
	async getSosmedAccountList({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getSosmedAccountList(params).then(({ data: { data } }) => {
				commit('setSosmedAccountList', data.results);
				resolve(data.results);
			}).catch(() => {
				commit('setSosmedAccountList', []);
			});
		});
	},
	async actSetOngkir({ commit }, data) {
		commit('setOngkir', data);
	},
	async actLatLon({ commit }, params) {
		commit('setLatLon', params);
	},
	async getCourier({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getCourier(params).then(({ data: { data } }) => {
				commit('setCourier', data.results);
				resolve(true);
			}).catch(() => {
				commit('setCourier', []);
			});
		});
	},
	async getOngkir({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getOngkir(params).then(({ data: { data } }) => {
				if (params.weight <= 0) {
					commit('setOngkir', []);
				} else {
					commit('setOngkir', data.results);
				}
				resolve(data.results);
			}).catch(() => {
				commit('setOngkir', []);
				reject(true)
			});
		});
	},
	async getShippingFeeKiriminajaExpress({ state, commit }, params) {
		return new Promise(async (resolve, reject) => {
			apiOptions.getShippingFeeKiriminajaExpress(params).then(async ({ data: { data } }) => {
				if (params.weight <= 0) {
					commit('setOngkir', []);
				} else {
					// console.log("data.results",data.results.results)
					let shipping = state.ongkir;
					let dataOngkir = await data.results.results
					// console.log("dataOngkir", dataOngkir)
					await dataOngkir.forEach((item, idx) => {
						let itemDetail = {
							id: item.service,
							code: item.service,
							cost: parseFloat(item.cost),
							etd: item.etd,
							group: item.group,
							description: item.group,
							name: item.service_name,
							service: item.service_type,
							type: 'express',
							cod: item.cod,
							drop: item.drop,
							raw: item
						};
						shipping.push(itemDetail);
					});
					await console.log("shipping", shipping)
					await commit('setOngkir', shipping);
				}
				resolve(data.results);
			}).catch(data => {
				commit('setOngkir', []);
				reject(data.message)
			});
		});
	},
	async getShippingFeeKiriminajaInstant({ state, commit }, params) {
		return new Promise(async (resolve, reject) => {
			apiOptions.getShippingFeeKiriminajaInstant(params).then(async ({ data: { data } }) => {
				if (params.weight <= 0) {
					commit('setOngkir', []);
				} else {
					// console.log("data.results",data.results.results)
					let shipping = state.ongkir;
					let dataOngkir = await data.results.results
					// console.log("dataOngkir", dataOngkir)
					await dataOngkir.forEach((item, idx) => {
						let itemDetail = {
							id: item.service,
							code: item.service,
							cost: parseFloat(item.cost),
							etd: item.etd,
							group: item.group,
							description: item.group,
							name: item.service_name,
							service: item.service_type,
							type: 'instant',
							raw: item,
							cod: false,
							drop: false,
						};
						shipping.push(itemDetail);
					});
					await console.log("shippingInstant", shipping)
					await commit('setOngkir', shipping);
				}
				resolve(data.results);
			}).catch(data => {
				// commit('setOngkir', []);
				reject(data.message)
			});
		});
	},
	async getProvince({ commit }) {
		return new Promise((resolve) => {
			apiOptions.getProvince().then(({ data: { data } }) => {
				commit('setProvince', data.results);
				resolve(true);
			}).catch(() => {
				commit('setProvince', []);
			});
		});
	},
	async getCity({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getCity(params).then(({ data: { data } }) => {
				commit('setCity', data.results);
				resolve(true);
			}).catch(() => {
				commit('setCity', []);
			});
		});
	},
	async getSubdistrict({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getSubdistrict(params).then(({ data: { data } }) => {
				commit('setSubdistrict', data.results);
				resolve(true);
			}).catch(() => {
				commit('setSubdistrict', []);
			});
		});
	},
	async getBankList({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getBankList(params).then(({ data: { data } }) => {
				commit('setListBank', data.results);
				resolve(true);
			}).catch(() => {
				commit('setListBank', []);
			});
		});
	},
	async getBankAccountList({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getBankAccountList(params).then(({ data: { data } }) => {
				commit('setBanAccountList', data.results);
				resolve(data.results);
			}).catch(() => {
				commit('setBanAccountList', []);
			});
		});
	},
	async getPaymentMethodList({ commit }, params) {
		return new Promise((resolve) => {
			apiOptions.getPaymentMethodList(params).then(({ data: { data } }) => {
				commit('setPaymentMethodList', data.results);
				resolve(true);
			}).catch(() => {
				commit('setPaymentMethodList', []);
			});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};